import { ApplicationNavigationStore } from './application-navigation-store.types';

export const initialConstants: Pick<
	ApplicationNavigationStore,
	'applicationId' | 'applicationType' | 'applicationStatus' | 'startPage'
> = {
	applicationId: null,
	applicationType: null,
	applicationStatus: null,
	startPage: '/personal-account/applications',
};
